var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"leave-active-class":_vm.fullscreen ? 'animate__animated animate__fadeOut' : ''}},[(_vm.show)?_c('div',{staticClass:"alert media",class:{
			'alert-info': _vm.message.severity == 'info',
			'alert-warning': _vm.message.severity == 'warn',
			'alert-danger': _vm.message.severity == 'error',
			'fullscreen': _vm.fullscreen
		}},[_c('font-awesome-icon',{staticClass:"fa-2x mr-3",attrs:{"icon":_vm.message.severity == 'info' ? 'info-circle' : 'exclamation-triangle'}}),_c('div',{staticClass:"media-body align-self-center"},[_vm._v(" "+_vm._s(_vm.message.text)+" ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }